import { Routes, Route, Navigate } from 'react-router-dom';
import { ProjectScope } from '../../components/ProjectScope';
import { Dashboard } from './Dashboard';
import { Programme } from './Programme';
import { Claims } from './Claims';
import { ClaimDetail } from './ClaimDetail';

export function ProgRoutes() {
  return (
    <ProjectScope
      storageKey="munin.prog.project"
      emptyBody="Progress assurance menggantung pada sebuah proyek dan programme-nya. Buat proyek lebih dulu."
    >
      {(projectId) => (
        <Routes>
          <Route path="/" element={<Dashboard projectId={projectId} />} />
          <Route path="/programme" element={<Programme projectId={projectId} />} />
          <Route path="/claims" element={<Claims projectId={projectId} />} />
          <Route path="/claims/:id" element={<ClaimDetail />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </ProjectScope>
  );
}
